export const prohibitedBusinessURLs = [
  "google.com",
  "facebook.com",
  "amazon.com",
  "apple.com",
  "microsoft.com",
  "netflix.com",
  "linkedin.com",
  "twitter.com",
  "instagram.com",
  "youtube.com",
  "yahoo.com",
  "wikipedia.org",
  "ebay.com",
  "reddit.com",
  "imgur.com",
  "spotify.com",
  "snapchat.com",
  "pinterest.com",
  "tumblr.com",
  "paypal.com",
  "quora.com"
];